import { generateDarkColor } from '@logto/core-kit';
import { SignInMode } from '../db-entries/index.js';
import { MfaFactor, MfaPolicy, OrganizationRequiredMfaPolicy, SignInIdentifier, } from '../foundations/index.js';
import { adminTenantId, defaultTenantId } from './tenant.js';
export const defaultPrimaryColor = '#6139F6';
export const createDefaultSignInExperience = (forTenantId, isCloud) => Object.freeze({
    tenantId: forTenantId,
    id: 'default',
    color: {
        primaryColor: defaultPrimaryColor,
        isDarkModeEnabled: false,
        darkPrimaryColor: generateDarkColor(defaultPrimaryColor),
    },
    branding: {},
    hideLogtoBranding: !isCloud,
    languageInfo: {
        autoDetect: true,
        fallbackLanguage: 'en',
    },
    termsOfUseUrl: null,
    privacyPolicyUrl: null,
    signUp: {
        identifiers: [isCloud ? SignInIdentifier.Email : SignInIdentifier.Username],
        password: true,
        verify: isCloud,
    },
    signIn: {
        methods: [
            {
                identifier: isCloud ? SignInIdentifier.Email : SignInIdentifier.Username,
                password: true,
                verificationCode: false,
                isPasswordPrimary: true,
            },
        ],
    },
    socialSignInConnectorTargets: [],
    signInMode: SignInMode.SignInAndRegister,
    customCss: null,
    customContent: {},
    customUiAssets: null,
    signUpProfileFields: null,
    passwordPolicy: {},
    mfa: {
        factors: [],
        policy: MfaPolicy.UserControlled,
    },
});
/** @deprecated Use `createDefaultSignInExperience()` instead. */
export const defaultSignInExperience = createDefaultSignInExperience(defaultTenantId, false);
export const createAdminTenantSignInExperience = (options = {}) => Object.freeze({
    ...defaultSignInExperience,
    tenantId: adminTenantId,
    color: {
        ...defaultSignInExperience.color,
        isDarkModeEnabled: true,
    },
    signInMode: SignInMode.Register,
    branding: {},
    passwordPolicy: options.disablePwnedPasswordCheck
        ? {
            ...defaultSignInExperience.passwordPolicy,
            rejects: {
                ...defaultSignInExperience.passwordPolicy?.rejects,
                pwned: false,
            },
        }
        : defaultSignInExperience.passwordPolicy,
    mfa: {
        factors: [MfaFactor.TOTP, MfaFactor.WebAuthn, MfaFactor.BackupCode],
        policy: MfaPolicy.NoPrompt,
        organizationRequiredMfaPolicy: OrganizationRequiredMfaPolicy.Mandatory,
    },
});
